import { styled, Button } from "@mui/material";

const StyledSecondaryButton = styled(Button)(({ theme }) => ({
  color: theme.palette.widgetStyles.button.secondary.textColor,
  borderRadius: "52px",
  border: `2px solid ${theme.palette.widgetStyles.button.secondary.backgroundColor}`,
  fontWeight: "600",
  textTransform: "none",
  minHeight: "44px",
  fontSize: "17px",
  boxShadow: "none",
  backgroundColor: "#ffff",
  transition: "all 150ms ease-in-out",
  paddingLeft: "24px",
  paddingRight: "24px",
  display: "inline-flex",
  alignItems: "center",
  textAlign: "center",
  justifyContent: "center",
  textDecoration: "none",
  lineHeight: "22px",

  "&:hover": {
    backgroundColor: theme.palette.widgetStyles.button.secondary.hoverColor,
    borderColor: theme.palette.widgetStyles.button.secondary.hoverColor,
    cursor: "pointer",
    color: theme.palette.widgetStyles.button.primary.textColor,
    boxShadow: "none",
  },
}));

export default StyledSecondaryButton;
